(() => {
  for (const root of document.querySelectorAll('[data-product-detail]')) {
    const choices = [...root.querySelectorAll('[data-product-variant]')];
    const single = root.querySelector('[data-product-variant-single]');
    const price = root.querySelector('[data-product-price]');
    const skuNode = root.querySelector('[data-product-sku]');
    const whatsapp = root.querySelector('[data-product-inquiry="whatsapp"]');
    const email = root.querySelector('[data-product-inquiry="email"]');
    const copyButton = root.querySelector('[data-product-copy]');
    const shareButton = root.querySelector('[data-product-share]');
    const shareText = root.querySelector('[data-product-share-text]');
    const status = root.querySelector('[data-product-share-status]');
    const selectedChoice = () => root.querySelector('[data-product-variant]:checked') || single;
    const productUrl = () => window.location.protocol === 'https:' && !/^(localhost|127\.|\[::1\])/.test(window.location.hostname) ? window.location.href : '';
    const message = (key, fallback) => root.dataset['i18n' + key] || fallback;
    const context = () => { const choice = selectedChoice(); const model = root.dataset.productModel || ''; const sku = choice?.dataset.variantSku || ''; const variant = choice?.dataset.variantTitle || ''; return {model, sku, variant, text: `${message('EnquiryGreeting', 'Hello PALERILL, I am interested in')} ${model} / ${sku} / ${variant}. ${message('EnquiryPrompt', 'My project location and timeline are:')} `}; };
    const refresh = () => {
      const choice = selectedChoice(); if (!choice) return;
      price.textContent = choice.dataset.variantPrice || ''; skuNode.textContent = choice.dataset.variantSku || '';
      const {model, sku, variant, text} = context();
      whatsapp.href = `https://wa.me/13468469968?text=${encodeURIComponent(text)}`;
      email.href = `mailto:sales@palerill.com?subject=${encodeURIComponent(`${model} ${message('EnquirySubject', 'Project enquiry')}`)}&body=${encodeURIComponent(text)}`;
      shareText.value = [root.dataset.productTitle, `${message('ModelLabel', 'Model')}: ${model}`, `${message('VariantLabel', 'Variant')}: ${variant}`, `SKU: ${sku}`, productUrl()].filter(Boolean).join('\n');
    };
    choices.forEach(choice => choice.addEventListener('change', refresh));
    copyButton?.addEventListener('click', async () => { try { await navigator.clipboard.writeText(shareText.value); status.textContent = message('Copied', 'Product details copied.'); } catch { shareText.focus(); shareText.select(); status.textContent = message('CopySelected', 'Product details selected. Use your device copy command.'); } });
    if (shareButton && navigator.share && productUrl()) { shareButton.hidden = false; shareButton.addEventListener('click', async () => { try { await navigator.share({title: root.dataset.productTitle, text: shareText.value, url: productUrl()}); } catch (error) { if (error?.name !== 'AbortError') status.textContent = message('ShareUnavailable', 'Sharing is unavailable. Copy the product details instead.'); } }); }
    refresh();
  }
})();

/* --- Dual-unit fallback (added 2026-10-08) --------------------------------
   Stored option values already carry an inch equivalent after the 2026-10-08
   rewrite. This pass only exists so that any product added later, whose size
   is still metric-only, renders as "80 cm (31.5 in)" without a data change.
   It is idempotent: anything already showing inches is left untouched.        */
(() => {
  const NUM = '\\d+(?:[.,]\\d+)?';
  const UNIT = new RegExp('(' + NUM + '(?:\\s*[x\u00d7]\\s*' + NUM + ')*)\\s*(cm|mm|m)\\b', 'gi');
  const DONE = new RegExp('(\\(\\s*[\\d.,]+(?:\\s*[x\u00d7]\\s*[\\d.,]+)*\\s*in\\s*\\)|' + NUM + '\\s*(?:"|\u2033)|\\binch(?:es)?\\b|\\bft\\b|\\bfeet\\b|\\bmm\\s*\\()', 'i');
  const F = { mm: 0.1, cm: 1, m: 100 };
  const fmt = x => { const s = x.toFixed(1); return s.slice(-2) === '.0' ? s.slice(0, -2) : s; };
  const convert = s => {
    if (!s || DONE.test(s)) return s;
    return s.replace(UNIT, (whole, chain, unit) => {
      const u = unit.toLowerCase();
      const nums = chain.match(/\d+(?:[.,]\d+)?/g) || [];
      const cms = nums.map(n => parseFloat(n.replace(',', '.')) * F[u]);
      if (!cms.length || cms.some(c => !isFinite(c) || c > 3000 || c < 0.5)) return whole;
      return chain + ' ' + u + ' (' + cms.map(c => fmt(c / 2.54)).join(nums.length > 1 ? 'x' : '') + ' in)';
    });
  };
  const pass = () => {
    document.querySelectorAll('[data-product-detail] .am-variant-card strong').forEach(el => {
      const before = el.textContent, after = convert(before);
      if (after !== before) el.textContent = after;
    });
    document.querySelectorAll('[data-product-detail] [data-variant-title]').forEach(el => {
      const before = el.getAttribute('data-variant-title') || '', after = convert(before);
      if (after !== before) el.setAttribute('data-variant-title', after);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pass);
  else pass();
})();
